/**
 * DAT-561 · The one place that defines how an external surface (today: the Employee Status Review
 * in-app notification) asks the Team page to open in "needs decision only" mode.
 *
 * Team's filter state now lives entirely in the URL, so this parameter no longer needs applying and
 * stripping — it simply IS the decisions view, and `teamUrlState.ts` reads it like any other facet.
 */

export const TEAM_NEEDS_DECISION_PARAM = "needs_decision";

export const TEAM_NEEDS_DECISION_VALUE = "true";

export function buildTeamNeedsDecisionUrl(departmentId: string): string {
	return `/${departmentId}/team?${TEAM_NEEDS_DECISION_PARAM}=${TEAM_NEEDS_DECISION_VALUE}`;
}
